import { AuthorizationActionsUnion, AuthorizationActionTypes } from './user.actions';
import { UserState } from './user.model';

export const inRoomUserFeatureKey = 'inroom-user';

const initialState: UserState = {
  access_token: undefined,
};

export function userReducer(state: UserState = initialState, action: AuthorizationActionsUnion): UserState {
  switch (action.type) {
    case AuthorizationActionTypes.AUTH_API_LOGGED_IN:
      return {
        ...state,
        access_token: action.payload.access_token,
      };
    default:
      return state;
  }
}
